// forked and modified from 'https://github.com/gaearon/redux-thunk'
function createThunkMiddleware(extraArgument?) {
  return ({ dispatch, getState }) => next => action => {
    if (typeof action === 'function') {
      if (getState().serverRendered) {
        return Promise.resolve(null)
      }
      return action(dispatch, getState, extraArgument)
    }
    return next(action)
  }
}

const reduxThunk: any = createThunkMiddleware()
reduxThunk.withExtraArgument = createThunkMiddleware

export default reduxThunk
